<div class="m-fiscal-calendar p-3" [class.compare-mode]="compareMode()">
  <div class="calendar-navigation">
    @for (viewer of viewers(); track viewer.viewerType) {
      <div
        class="period-section"
        [class.current-period]="viewer.viewerType === 'current'"
        [class.previous-period]="viewer.viewerType === 'previous'">
        <div class="months-container">
          @for (
            month of getVisibleMonths(viewer);
            track month.label;
            let showLeftNavigationArrow = $first;
            let showRightNavigationArrow = $last
          ) {
            <ng-container
              *ngTemplateOutlet="
                calendarTable;
                context: {
                  month: month,
                  showLeftNavigationArrow: showLeftNavigationArrow,
                  showRightNavigationArrow: showRightNavigationArrow,
                  viewer: viewer,
                  isCompareModeOn: viewer.viewerType === 'previous',
                }
              "></ng-container>
          }
        </div>
        @if (compareMode()) {
          <span class="b2 text-gray-1000 text-center mt-2">{{
            viewer.viewerType === "current"
              ? "Current Time Period"
              : "Comparison Time Period"
          }}</span>
        }
      </div>
    }
  </div>
</div>

<ng-template
  #calendarTable
  let-month="month"
  let-showLeftNavigationArrow="showLeftNavigationArrow"
  let-showRightNavigationArrow="showRightNavigationArrow"
  let-viewer="viewer"
  let-isCompareModeOn="isCompareModeOn">
  <div class="calendar-table">
    <table class="month-table">
      <thead>
        <tr>
          <th colspan="9" class="month-header">
            <div class="month-header-content">
              <!-- Always render nav button container to maintain centering -->
              <div class="nav-btn-container">
                @if (showLeftNavigationArrow) {
                  <button
                    class="nav-btn prev"
                    (click)="navigateLeft(viewer)"
                    [disabled]="!canNavigateLeft(viewer)"></button>
                }
              </div>
              <div class="month-info">
                <span class="sh2 text-gray-1000">{{ month.label }}</span>
                <span class="c1 text-gray-700 block">{{
                  month.dateRangeLabel || ""
                }}</span>
              </div>
              <!-- Always render nav button container to maintain centering -->
              <div class="nav-btn-container">
                @if (showRightNavigationArrow) {
                  <button
                    class="nav-btn next"
                    (click)="navigateRight(viewer)"
                    [disabled]="!canNavigateRight(viewer)"></button>
                }
              </div>
            </div>
          </th>
        </tr>
        <tr class="week-days">
          <th class="week-number-header">
            <span></span>
          </th>
          @for (day of weekDays; track day) {
            <th>
              <span>{{ day }}</span>
            </th>
          }
          <th class="month-name-header"><span></span></th>
        </tr>
      </thead>
      <tbody>
        @for (week of month.weeks; track weekIdx; let weekIdx = $index) {
          <tr [class.empty-row]="isEmptyWeek(week)">
            <td class="week-number-cell" [class.empty-week]="isEmptyWeek(week)">
              @if (!isEmptyWeek(week)) {
                <span>{{ month.weekNumbers[weekIdx] }}</span>
              }
            </td>
            @for (i of getRange(weekIdx * 7, weekIdx * 7 + 7); track i) {
              <td
                [ngClass]="
                  getDayClasses(month.days[i], viewer.viewerType, week, i % 7)
                "
                (click)="onDateClick(month.days[i], viewer.viewerType)">
                <span>{{ getDayOfMonth(month.days[i]) }}</span>
              </td>
            }
            @if (
              monthSpanCalculator.isSpanStart(month.days, weekIdx) &&
              !isEmptyWeek(week)
            ) {
              <td
                class="month-name-cell"
                [class.month-separator]="
                  monthSpanCalculator.needsSeparatorBorder(month.days, weekIdx)
                "
                [attr.rowspan]="
                  monthSpanCalculator.getRowspan(month.days, weekIdx)
                ">
                <span>{{
                  monthSpanCalculator.getMonthName(month.days, weekIdx)
                }}</span>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</ng-template>
